<router-outlet>

</router-outlet>
<p-toast/>
@if (loading()) {
    <div class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center " style="z-index: 99999999">
        <div class=" p-4 rounded-lg w-[9%]">
            <div class="loader"></div>
        </div>
    </div>
}
